
/* injects from baggage-loader */
require('./salesperson-name.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('salespersonName', {
    templateUrl: '/app/components/deal-sheet/contract/salesperson-name.component.html',
    bindings: {
        value: '<'
    }
});
